import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoProduto } from "models/modelo_item_orcamento_produto";
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MdDelete, MdEdit } from "react-icons/md";
import formatNumber from "../../hooks/formatNumber";
import DynamicTable from "./DynamicTable";
import ItemProdutoTable from "./ItemTable";

interface ITemplateData {
  showItemModal: (item: boolean) => void;
  showCategory: boolean;
  textColor: string;
  brandStars: string;
  nomeRef: any;
  saveItem: () => void;
  changeItem: (item: ModeloItemOrcamentoCategoria) => void;
  removeItem: (item: ModeloItemOrcamentoCategoria) => void;
  itens: ModeloItemOrcamentoCategoria[];
  reorder: (
    list: ModeloItemOrcamentoCategoria[],
    startIndex: number,
    endIndex: number
  ) => void;
  drag: boolean;
  isDragable: (drag: boolean) => void;
  borderColor: string;
  condicaoPagamento: CondicaoPagamento[] | undefined;
  itemList: ModeloItemOrcamentoProduto[];
  addRowItem: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
  editRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
  deleteRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void
}

const TemplateData = ({
  showItemModal,
  showCategory,
  textColor,
  brandStars,
  nomeRef,
  saveItem,
  changeItem,
  removeItem,
  reorder,
  drag,
  isDragable,
  itens,
  borderColor,
  condicaoPagamento,
  addRowItem,
  deleteRow,
  editRow,
  itemList
}: ITemplateData) => {
  const [selectedItem, setSelectedItem] =
    useState<ModeloItemOrcamentoCategoria>();

  const [isEdit, setIsEdit] = useState(false);
  const editItem = (item: ModeloItemOrcamentoCategoria) => {
    setIsEdit(true);
    nomeRef.current = item.descricao;
    showItemModal(true);
    setSelectedItem(item);
  };

  const saveEdit = () => {
    selectedItem.descricao = nomeRef.current;
    setIsEdit(false);
    nomeRef.current = "";
    changeItem(selectedItem);
    setSelectedItem(null);
    showItemModal(false);
  };

  const onDragEnd = (result: any) => {
    reorder(itens, result.source.index, result.destination.index);
  };
  return (
    <Box>
      <Stack>
        <Button
          marginY={-5}
          variant={"outline"}
          onClick={() => {
            showItemModal(true);
          }}
          alignSelf={"flex-end"}
          colorScheme="brand"
          isLoading={false}
        >
          Adicionar Novo Grupo
        </Button>
      </Stack>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {provided.placeholder}
              {itens?.map((item, index) => {
                return (
                  <Draggable
                    key={`${item.id}`}
                    draggableId={`${item.id}-${item.descricao}-${index}`}
                    index={index}
                    isDragDisabled={drag}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Box key={`${item.id}-${index}`} mb={16} mt={16}>
                          <Box flex="1" flexDirection={"row"}>
                            <Text
                              textAlign="left"
                              color={"#422AFB"}
                              fontWeight={"bold"}
                              fontSize={28}
                            >
                              {index + 1} - {item.descricao} - subtotal :{" "}
                              {formatNumber(Number(item.valor))}
                            </Text>

                            <Button
                              leftIcon={<MdDelete />}
                              colorScheme="red"
                              variant="solid"
                              float={"right"}
                              mt={-12}
                              onClick={() => removeItem(item)}
                            >
                              Excluir
                            </Button>
                            <Button
                              leftIcon={<MdEdit />}
                              colorScheme="green"
                              variant="solid"
                              float={"right"}
                              mt={-12}
                              mr={128}
                              onClick={() => {
                                editItem(item);
                              }}
                            >
                              Editar
                            </Button>
                          </Box>

                          <Text
                            textAlign="left"
                            color={"#422AFB"}
                            fontWeight={"bold"}
                            mt={20}
                            fontSize={20}
                          >
                            SERVIÇOS
                          </Text>
                          <DynamicTable
                            borderColor={borderColor}
                            index={index}
                            changeItem1={changeItem}
                            isDragable={isDragable}
                            item={item}
                            condicaoPagamento={condicaoPagamento}
                          />

                          <Text
                            textAlign="left"
                            color={"#422AFB"}
                            fontWeight={"bold"}
                            mt={20}
                            fontSize={20}
                          >
                            PRODUTOS
                          </Text>
                          <ItemProdutoTable
                            addRowItem={addRowItem}
                            borderColor={borderColor}
                            deleteRow={deleteRow}
                            editRow={editRow}
                            itemList={itemList}
                            categ={item}
                          
                          />
                        </Box>
                      </div>
                    )}
                  </Draggable>
                );
              })}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Modal
        onClose={() => {
          showItemModal(false);
        }}
        size={"2xl"}
        isOpen={showCategory}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isEdit ? "Editar Grupo" : "Novo Grupo"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nome<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                ref={nomeRef}
                defaultValue={nomeRef.current}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o nome do Grupo"
                onChange={(e) => (nomeRef.current = e.target.value)}
                mb="24px"
                fontWeight="500"
                size="lg"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                showItemModal(false);
              }}
              variant="outline"
              marginRight={4}
            >
              Fechar
            </Button>
            <Button
              onClick={() => {
                isEdit ? saveEdit() : saveItem();
              }}
              colorScheme="brand"
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TemplateData;
